import { useModalStore } from '@/entities/Modal';
import { ResponseError } from '@/shared/api/types';
import { useMutation } from '@tanstack/react-query';
import { register } from '../api/registerQuery';

export const useRegister = () => {
    const { setErrorModalProps } = useModalStore();

    return useMutation({
        mutationFn: register,
        onSuccess: (url) => {
            window.location.href = url;
        },
        onError: (error: ResponseError) => {
            const errorMessage = error.response.data.details[0] || 'Что-то пошло не так';

            setErrorModalProps({ isOpened: true, title: errorMessage });
        },
    });
};
